import React from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { reduxForm, Field } from 'redux-form';

import {
  getActionsByToken,
  submitActionReport,
} from '../../actions/reportActions';
import ReportInput from '../../components/ReportInput';
import Confirmed from './Confirmed';

import './styles.css';


class Report extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      actions: [],
      loading: true,
    };

   this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    const { match, getUserActions, report } = this.props;
    if (!report || !report.actions) {
      getUserActions(match.params.token);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { actions } = nextProps.report;

    if (actions) {
      this.setState({ actions, loading: false })
    }
  }

  onSubmit = async (e) => {
    e.preventDefault();
    const {
      submitReport,
      actionReport,
      match,
    } = this.props;

    this.setState({ loading: true });
    try {
      const res = await submitReport(actionReport, match.params.token);
      this.setState({
        loading: false,
        complete: true,
        completions: res.completions,
      });
    } catch (err) {
      this.setState({
        loading: false,
        error: err.error,
      });
    }
  }

  render() {
    const { actions } = this.state;
    let actionInputs = [];
    if (actions.length > 0) {
      actionInputs = actions.map((ua) => (
        <Field
          key={ua.taskId}
          name={ua.taskId}
          component={ReportInput}
          props={{ message: ua.message }}
        />
      ));
    }

    if (this.state.complete) {
      setTimeout(() => {
        this.props.history.push('/');
      }, 6000);

      return (
        <Confirmed completions={this.state.completions} />
      );
    }

    return (
      <div className="report_main">
        <div className="report_container">
          <div className="report_leftColumn">
            <div className="report_logoContainer">
              <Link className="report_homeLink" to="/">
                <img alt="report_balooLogo"
                     src="https://storage.googleapis.com/baloo-media/image/logo.png"
                     className="report_logo" />
                <div className="report_balooTitle">
                  baloo
                </div>
              </Link>
            </div>
          </div>
          <div className="report_rightColumn">
            <div className="report_rightHeader">
              Record Actions
            </div>
            <form className="report_form" onSubmit={this.onSubmit}>
              { actionInputs }
              <div className="report_formError">
                { this.state.error }
              </div>
              <button
                className="report_submit"
                disabled={this.state.loading}
                type="submit"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
};

const mapStateToProps = state => ({
  report: state.report,
  actionReport: _.get(state.form, 'actionReport.values'),
});

const mapDispatchToProps = dispatch => ({
  getUserActions: token => (dispatch(getActionsByToken(token))),
  submitReport: (report, token) => (
    dispatch(submitActionReport(report, token))
  ),
});

const enhance = compose(
  withRouter,
  reduxForm({
    form: 'actionReport',
  }),
  connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(Report);



// WEBPACK FOOTER //
// ./src/views/Report/index.js